import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
// import profile from "/public/profile.jpeg"
// profile="public/profile.jpeg"
// import html from './Imgs/Html.png';

const Home = () => {
  return (
    //Name attribute is for smooth scroll
    <div
      name="home"
      className="h-dvh w-full bg-gradient-to-b from-black via-black to-gray-800 text-white"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center gap-x-4 justify-center h-full px-4 md:flex-row">
            <div className="flex flex-col justify-center pt-24 sm:mt-24 md:pt-0 h-full">
                <h1 className="text-lg sm:text-6xl font-bold text-white font-serif">
                    I'm a Computer System Engineer!
                </h1>
                <p className="text-gray-300 text-sm md:text-xl  font-sans py-4">
                    An Associate Software Engineer at Geeks of Kolachi. <br/>
                    Studied Computer System Engineering at "Dawood
                    University of Engineering and Technology". <br/> 
                    Experienced in Web and Mobile development | AI | Machine Learning | Deep Learning | Federated Learning.
                </p>
                <div>
                  <a href="public/portfolio.pdf" download="Amber's Resume.pdf"
                    className="group text-white w-fit px-6 py-3 my-2
                            flex items-centre rounded-md bg-gradient-to-r from-cyan-500 to-blue-600 cursor-pointer text-xl md:text-2xl"
                    >
                    {" "}
                    portfolio
                    <span className="group-hover:rotate-90 duration-300">
                        <MdKeyboardArrowRight size={25} className="ml-1" />
                    </span>
                    
                    </a>
                </div>
            </div>
            <div className="mt-0 sm:mt-24">
            <img
                src="github1.jpg"
                alt="My-Profile"
                className="rounded-2xl mx-auto h-96 md:w-full"
            />
            </div>
      </div>
    </div>
  );
};

export default Home;
